import { useContext } from 'react'
import api from '../../api'
import { ProjectContext } from '../../contexts'
import { List, ListCreateParams } from '../../types'
import FormWrapper from '../../ui/form/FormWrapper'
import RadioInput from '../../ui/form/RadioInput'
import TextInput from '../../ui/form/TextInput'
import { TagPicker } from '../settings/TagPicker'
import { useTranslation } from 'react-i18next'
import { createWrapperRule } from './rules/RuleHelpers'
import { listTypes } from './ListFields'

interface ListCreateFormProps {
    folderId?: number
    onCreated?: (list: List) => void
}

export function ListCreateForm({ folderId, onCreated }: ListCreateFormProps) {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)
    const defaults: Partial<ListCreateParams> = {
        type: 'dynamic',
        rule: createWrapperRule('parent'),
    }

    return (
        <FormWrapper<ListCreateParams>
            onSubmit={
                async list => {
                    const rule = list.rule ?? createWrapperRule()
                    const created = await api.lists.create(project.id, {
                        ...list,
                        rule: list.type === 'dynamic' ? rule : undefined,
                        is_visible: true,
                        folder_id: folderId,
                    })
                    onCreated?.(created)
                }
            }
            defaultValues={defaults}
            submitLabel={t('save')}
        >
            {form => (
                <>
                    <TextInput.Field
                        form={form}
                        name="name"
                        label={t('list_name')}
                        required
                    />
                    <TextInput.Field
                        form={form}
                        name="description"
                        label={t('description')}
                        textarea
                        autosize
                    />
                    <RadioInput.Field
                        form={form}
                        name="type"
                        label={t('type')}
                        subtitle={t('list_type_subtitle')}
                        options={listTypes(t)}
                        required
                    />
                    <p className="label-subtitle" style={{ margin: '5px 0 15px' }}>
                        {form.watch('type') === 'static'
                            ? t('list_type_static_description')
                            : t('list_type_dynamic_description')}
                    </p>
                    <TagPicker.Field
                        form={form}
                        name="tags"
                        label={t('tags')}
                    />
                </>
            )}
        </FormWrapper>
    )
}
